module.exports = __webpack_public_path__ + "img/button_delete_anots.20cb3bf0.svg";